var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.92356 0 0 4.92356 0 11C0 17.0764 4.92356 22 11 22C17.0764 22 22 17.0764 22 11C22 4.92356 17.0764 0 11 0ZM9.3024 14.8976C9.17548 15.0245 8.99567 15.1303 8.83702 15.1303C8.67836 15.1303 8.49856 15.0192 8.36635 14.8923L5.40481 11.9308L6.34615 10.9894L8.84231 13.4856L15.4423 6.83798L16.3678 7.79519L9.3024 14.8976Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyTick);
export default __webpack_public_path__ + "static/media/GreyTick.9ffc43c16a09f9a1cbc7b544302ba674.svg";
export { ForwardRef as ReactComponent };